import { render, staticRenderFns } from "./order_detail_list.vue?vue&type=template&id=00e175cf&scoped=true"
import script from "./order_detail_list.vue?vue&type=script&lang=js"
export * from "./order_detail_list.vue?vue&type=script&lang=js"
import style0 from "./order_detail_list.vue?vue&type=style&index=0&id=00e175cf&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e175cf",
  null
  
)

export default component.exports